<template>
  <b-modal
      ref="modal"
      id="approve-application-modal"
      title="Please confirm"
      centered
      ok-title="Confirm"
      ok-variant="success"
      @ok="confirmApprove"
  >
    <h4>You are going to approve this application</h4>
    <hr>
    <b-form-group label="Facility permissions">
      <b-form-checkbox
          v-model="formData.is_to_buy"
          :value="true"
          :unchecked-value="false"
      >
        Permit <strong>Purchase</strong> operations
      </b-form-checkbox>
      <hr>
      <b-form-checkbox
          v-model="formData.is_to_sell"
          :value="true"
          :unchecked-value="false"
      >
        Permit <strong>Sale</strong> operations
      </b-form-checkbox>
    </b-form-group>
  </b-modal>
</template>

<script>
export default {
  name: "AdminApplicationApproveModal",
  emits: ['confirm'],
  data() {
    return {
      formData: {
        is_to_buy: false,
        is_to_sell: false
      }
    }
  },
  methods: {
    open() {
      this.$root.$emit('bv::show::modal', 'approve-application-modal');
    },
    confirmApprove() {
      this.$emit('confirm', this.formData);
    }
  }
}
</script>
